// removed by extract-text-webpack-plugin
module.exports = {"Card":"ctikhJDFLDkyfgp9pmcep","PaginationWrap":"_2Iu8FTLA96NumjLnxtmPv0","ActiveLink":"_1YTrwQZLkgALGPotrevXj_","FiltersToggle":"MvQHKiSouQi4hJIhzbx2B","MainColumn":"_3H3TCkqeK0GyuZu4SMKo0D","SidebarColumn":"_20rRRTeKZ7_FlZJMZUAwJx"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Payouts/styles.module.css
// module id = 638
// module chunks = 0